import { Workbox } from 'workbox-window'

export interface SwUpdateController {
  /** Triggers `skipWaiting` on the new service worker, then reloads the page once it activates. */
  applyUpdate: () => void
}

export type SwUpdateListener = (ctrl: SwUpdateController) => void

/**
 * Registers the service worker on app start.
 *
 * Calls `onUpdateAvailable` exactly once when a new SW is in the `waiting`
 * state — the React layer can then show a "Aggiornamento disponibile" banner
 * and let the user opt in. The user's "Aggiorna" button calls
 * `ctrl.applyUpdate()` which messages the new SW to skip waiting; the page
 * reloads automatically when the new SW takes control.
 *
 * No-op outside of HTTPS and outside of production builds (vite-plugin-pwa
 * doesn't emit a service worker in dev mode).
 */
export function registerServiceWorker(onUpdateAvailable: SwUpdateListener): void {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  const wb = new Workbox('/sw.js')

  // When a new SW is waiting (i.e., user has an old version active), notify React.
  wb.addEventListener('waiting', () => {
    onUpdateAvailable({
      applyUpdate: () => {
        // Listen for the new SW taking control, then reload once.
        wb.addEventListener('controlling', () => {
          window.location.reload()
        })
        wb.messageSkipWaiting()
      },
    })
  })

  wb.register().catch((err) => {
    // Service worker failures shouldn't block the app — just log.
    // eslint-disable-next-line no-console
    console.warn('Service worker registration failed:', err)
  })
}
